var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#00F",
  viewBox: "0 0 249 249"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 19.671C0 12.933 0 9.564 1.27 6.973A12.45 12.45 0 0 1 6.973 1.27C9.564 0 12.933 0 19.67 0h209.658c6.738 0 10.107 0 12.698 1.27a12.45 12.45 0 0 1 5.703 5.703C249 9.564 249 12.933 249 19.67v209.658c0 6.738 0 10.107-1.27 12.698a12.45 12.45 0 0 1-5.703 5.703c-2.591 1.27-5.96 1.27-12.698 1.27H19.671c-6.738 0-10.107 0-12.698-1.27a12.45 12.45 0 0 1-5.703-5.703C0 239.436 0 236.067 0 229.329z"
})));
export default SvgBase;